import { useBrandConfig } from '~/config/branding';

export const SecurityPage = () => {
  // [MCV-1490] The security copy was entirely MedCredVault-framed. The technical
  // paragraphs below describe the same underlying platform for both brands and
  // stay shared; only the opening, which names the product, is brand-specific so
  // the HealthcareLX site reads as being about HealthcareLX.
  const { brand } = useBrandConfig();
  return (
    <div className="text-left flex-1 bg-white py-10 sm:py-32">
      <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="mx-auto max-w-3xl text-left">
          <p className="text-base/7 font-semibold text-primary-50">Security</p>
          <h1 className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-grey-100 sm:text-5xl">
            Store, manage, and share credentials securely
          </h1>
        </div>
        <div className="mx-auto mt-10 max-w-3xl space-y-6 text-base/7 text-grey-300">
          {brand === 'hlx' ? (
            <p>
              HealthcareLX is built for healthcare hiring and credentialing workflows where
              professional credentials, identity details, and supporting documents need to be
              handled with care. Providers can centralize licenses, certifications, DEA/CDS
              registrations, education, employment history, malpractice records, and other
              credentialing materials in one structured vault, then share them into marketplace
              workflows on their own terms.
            </p>
          ) : (
            <p>
              Marketplace AI's MedCredVault is built for healthcare credentialing workflows where
              professional credentials, identity details, and supporting documents need to be
              handled with care. Providers can centralize licenses, certifications, DEA/CDS
              registrations, education, employment history, malpractice records, and other
              credentialing materials in one structured vault.
            </p>
          )}
          <p>
            Sensitive data is protected through layered encryption practices, including field-level
            encryption for operational PII and post-quantum encryption for document and
            key-management workflows. The platform minimizes exposure by excluding high-risk fields
            from AI/export paths.
          </p>
          <p>
            Access is controlled through authenticated user sessions, ownership checks,
            employer/provider role enforcement, and service-level protections for internal
            workflows. Sharing is intentionally scoped: delegated access is validated server-side
            against active provider-employer associations, so employers can only view or manage
            credentialing information.
          </p>
          <p>
            Providers remain in control of credential sharing through invitation, acceptance, and
            revocation flows. This allows organizations to collaborate on credentialing while
            preserving audit-friendly boundaries around who can access vault data.
          </p>
        </div>
      </div>
    </div>
  );
};
